import React from "react";
import Title from "../components/Title";

const About = () => {
  return (
    <div className="about-container">
      <h2 className="title">About Us</h2>
      <p>
        At Singh Engineering Solutions, we specialise in offshore
        decommissioning, subsea installation, and project management across the
        energy sector. Founded in 2010, SESLtd has built a reputation as a
        trusted technical partner for major North Sea operators and offshore
        contractors. With over 23 years in mechanical and subsea engineering,
        the team at SESLtd has led multiple high-profile decommissioning and
        construction projects for high profile O&G Operators and Tier 1
        Contractors. We pride ourselves on providing expert technical
        leadership, detailed engineering procedures, and offshore client
        representation that ensures every campaign meets the highest safety,
        quality, and environmental standards.
      </p>

      <h2 className="title">Our Mission</h2>
      <p>
        To lead the offshore industry in responsible, safe, and sustainable
        decommissioning practices. We are committed to minimising environmental
        impact while delivering efficient, cost-effective, and compliant
        engineering solutions. Our mission is to help energy companies
        transition to the future — through smart decommissioning, integrated
        engineering, and sustainable offshore operations.
      </p>

      <h2 className="title">Our Services</h2>
      <p>
        We offer a comprehensive range of engineering and project consultancy
        services designed for operators, contractors, and developers in the oil,
        gas, and renewables sectors:-
        <ul>
          <li>Decommissioning and Planning and Management</li>

          <li>Subsea Engineering & Construction Support</li>

          <li>Regulatory & Technical Compliance</li>

          <li>Offshore Client Representation</li>

          <li>Project Readiness and Quality Assurance</li>
        </ul>
      </p>

      <h2 className="title">Our Expertise</h2>

      <p>
        With decades of hands-on project experience across offshore oil, gas,
        and renewables, SESL delivers the full suite of engineering and
        decommissioning solutions. Our proven track record includes:
        <ul>
          <li>Subsea installation and recovery </li>
          <li>Platform and pipeline decommissioning </li>
          <li>Diving and ROV campaigns </li>
          <li>Heavy-lift operations </li>
          <li>Quality and readiness assurance </li>
        </ul>
        We are trusted by major operators for our technical leadership,
        strategic project management, and commitment to operational safety.
      </p>

      <h2 className="title">Commitment to Sustainability</h2>

      <p>
        Sustainability is at the heart of our business. We integrate
        environmental best practices into every decommissioning and construction
        activity, focusing on waste reduction, carbon efficiency, and seabed
        preservation. By combining innovation with responsibility, we ensure
        that each project leaves a positive environmental legacy.
      </p>

      <h2 className="title">Why Choose Us?</h2>
      <ul>
        <li>
          Industry Leaders: We are at the forefront of the oil and gas
          decommissioning sector, setting benchmarks for excellence.
        </li>

        <li>
          Tailored Solutions: We understand that every project is unique, and we
          provide customized solutions to meet specific client needs.
        </li>

        <li>
          Safety First: Safety is our top priority. We adhere to stringent
          safety protocols to protect our workforce and the environment.
        </li>

        <li>
          Proven Success: Our extensive portfolio of completed projects speaks
          to our capability and reliability in the field.
        </li>

        <li>
          Sustainability Focused: Environmentally conscious engineering
          solutions.
        </li>
      </ul>
    </div>
  );
};

export default About;
